import { memo } from 'react';
import { Card, Checkbox } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import StudioIcon from '../member-studios/StudioIcon';

/**
 * Studio checkbox cards of step 2: checkbox, icon and name on one line, as in the prototype.
 *
 * @param {object} props
 * @param {object[]} props.studios
 * @param {string[]} props.selectedIds
 * @param {(studioId: string) => void} props.onToggle
 */
const StudioCards = ({ studios, selectedIds, onToggle }) => {
  const { t } = useTranslation('people-access');
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {studios.map((studio) => (
        <Card key={studio.id} className={selectedIds.includes(studio.id) ? 'border-accent/60' : ''}>
          <label className="flex cursor-pointer items-center gap-3 p-4">
            <Checkbox
              checked={selectedIds.includes(studio.id)}
              aria-label={t('roles.builder.permissions.studioAria', { name: studio.name })}
              onChange={() => onToggle(studio.id)}
            />
            <StudioIcon icon={studio.icon} />
            <span className="min-w-0 truncate text-sm font-semibold text-content">{studio.name}</span>
          </label>
        </Card>
      ))}
    </div>
  );
};

export default memo(StudioCards);
